import React, { forwardRef, useCallback } from 'react';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import { MenuItem, ListItemIcon, Tooltip } from '@material-ui/core';
import styles from './styles';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { removeNoScroll } from '@/actions/Helper';

const NavLinkRef = forwardRef((props, ref) => (
  <NavLink innerRef={ref} {...props} />
));

export default forwardRef(({ leftIcon, onClick, sidebarIsOpen }, ref) => {
  const cls = styles();
  const handleMenuTap = useCallback((e) => onClick && onClick(e), [onClick]);
  const user = useSelector((state) => state.reducer.user);

  const { pathname } = useLocation();

  const enable_export = localStorage.getItem('enable_export');

  const renderMenuItem = () => (
    <MenuItem
      className={clsx(sidebarIsOpen ? cls.open : cls.close)}
      activeClassName={cls.active}
      component={NavLinkRef}
      ref={ref}
      to="/inventory"
      onClick={() => {
        handleMenuTap();
        removeNoScroll();
      }}>
      <ListItemIcon className={cls.listItemIcon}>{leftIcon}</ListItemIcon>
      <span className="DashboardItemText">Inventory</span>

      {user.id && (
        <div className="RequestResource" style={{ width: '100%' }}>
          {Number(enable_export) === 1 && (
            <div className={cls.child}>
              <MenuItem
                className={cls.item}
                activeClassName={cls.itemActive}
                component={NavLinkRef}
                ref={ref}
                to={
                  pathname === '/inventory/empty'
                    ? '/inventory/empty'
                    : '/inventory/empty/dropped'
                }
                isActive={() =>
                  pathname === '/inventory' ||
                  pathname === '/inventory/empty' ||
                  pathname === '/inventory/emptyAll/appointments' ||
                  pathname === '/inventory/emptyDropped/appointments' ||
                  pathname.startsWith('/inventory/empty/dropped') ||
                  pathname.startsWith('/inventory/empty/all') ||
                  pathname.startsWith('/inventory/empty/appointments')
                }
                onClick={handleMenuTap}>
                Import
              </MenuItem>
              <MenuItem
                className={cls.item}
                activeClassName={cls.itemActive}
                component={NavLinkRef}
                ref={ref}
                to="/inventory/export"
                onClick={handleMenuTap}>
                Export
              </MenuItem>
              {/* <MenuItem
                className={cls.item}
                activeClassName={cls.itemActive}
                component={NavLinkRef}
                ref={ref}
                to="/inventory/streetturn"
                onClick={handleMenuTap}>
                Street Turn
              </MenuItem> */}
            </div>
          )}
        </div>
      )}
    </MenuItem>
  );

  if (sidebarIsOpen) return renderMenuItem();

  return (
    <Tooltip arrow title="features" placement="right">
      {renderMenuItem()}
    </Tooltip>
  );
});
